import { render, staticRenderFns } from "./PostLightbox.vue?vue&type=template&id=34c63614"
import script from "./PostLightbox.vue?vue&type=script&lang=js"
export * from "./PostLightbox.vue?vue&type=script&lang=js"
import style0 from "./PostLightbox.vue?vue&type=style&index=0&id=34c63614&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports